const getters = {
  permissions: state => state.user.permissions,
  vipInfoUpdate:state => state.user.vipInfoUpdate,
  // permission_routes: state => state.permission.routes,

}
export default getters
